import { getObjectFromCacheOrFromEndpoint } from "../../utilities/cacheValidator";
import { getUserRolesFromEndpoint, IUserRoles } from "./storeRequests";
import { APIAnomalyError } from "../../services/ErrorHelpers";
import { IUserProviderState } from "../UserContext";

export async function getUserRoles(getTokenFn: IUserProviderState["accessToken"]): Promise<IUserRoles> {
  const fiscalYears = await getObjectFromCacheOrFromEndpoint<IUserRoles>(
    "UserRoles",
    getUserRolesFromEndpoint,
    getTokenFn
  );
  return fiscalYears;
}

export async function fetchAndParseUserRoles(getTokenFn: IUserProviderState["accessToken"]): Promise<IUserRoles> {
  const userRoles = await getUserRoles(getTokenFn);
  if (Object.keys(userRoles).length === 0) {
    throw new APIAnomalyError("Received empty Object for User Roles");
  }
  return userRoles;
}
